import type { SessionCard } from '../type';

/**
 * Kartya kereso fuggveny, amiben a hibat is kezeljuk ha nincs kartya!
 */
export function getCardById(
  cardId: SessionCard['id'],
  cards: SessionCard[],
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  caller: string,
): SessionCard | undefined {
  const card = cards.find(({ id }) => id === cardId);
  if (card === undefined) {
    // TODO ideiglenes
    // console.error(`[SessionState::${caller}] Not found card! => ${cardId}`);
  }

  return card;
}
